/**
 * @file
 * Global configuration objects.
 */

((window) => {
  window.dropdownOptions = {
    searchEnabled: false,
    shouldSort: false,
    itemSelectText: "",
    classNames: {
      containerOuter: "dropdown",
      containerInner: "dropdown__inner",
      input: "dropdown__input",
      inputCloned: "dropdown__input--cloned",
      list: "dropdown__list",
      listItems: "dropdown__list--multiple",
      listSingle: "dropdown__list--single",
      listDropdown: "dropdown__list--dropdown",
      item: "dropdown__item",
      itemSelectable: "dropdown__item--selectable",
      itemDisabled: "dropdown__item--disabled",
      itemChoice: "dropdown__item--choice",
      placeholder: "dropdown__placeholder",
      group: "dropdown__group",
      groupHeading: "dropdown__heading",
      button: "dropdown__button2"
    }
  };

  window.mainNavOptions = {
    containerSelector: ".js-site-container",
    innerWrapperSelector: ".js-header__wrapper",
    bottomSpacing: 1,
    resizeSensor: true
  };

  window.inPageNavOptions = {
    topOffset: 32,
    titleHighlightOffsetSmall: 88,
    titleHighlightOffsetLarge: 48
  };

  window.breakpoints = {
    large: "(min-width: 1100px)",
    xlarge: "(min-width: 1280px)"
  };
})(window);
